<template>
    <div class="order">
        <div class="order-top">
            <div class="order-head">
                <div class="order-line"></div>
                当前订单
            </div>
            <div class="order-content1">
                <div class="content-text" v-if="userinfo && userinfo.nickname">当前账号：<em>{{ userinfo.nickname }}</em></div>
                <div class="content-text" v-if="userinfo && userinfo.role_name">当前版本：<em>{{ userinfo.role_name }}</em></div>
                <div class="content-text" v-if="userinfo && userinfo.expiration_date">当前服务截止时间：<em>{{ formatDate(userinfo.expiration_date) }}</em></div>
                <el-button size="mini" type="primary" class="up-btn" @click="openUp">升级版本</el-button>
                <img :src="pay" alt="" class="top-hover pay" v-if="+userinfo.role_id > 0">
                <img :src="free" alt="" class="top-hover" v-else>
            </div>
            <div class="order-content2">
                <div class="order-head2">
                    <div class="order-line1"></div>
                    历史订单列表
                </div>
                <div class="order-list">
                    <el-table ref="filterTable" :data="tabelData" tooltip-effect="dark" style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <el-table-column :prop="item.key" :label="item.label" v-for="item in dataSource" :key="item.key"
                            :width="item.width || ''">
                            <template slot-scope="scope">
                                <div class="text" v-if="!slotmap.includes(item.key)">
                                    {{ scope.row[item.key] }}
                                </div>
                                <div class="text" v-if="item.key == 'add_time'">
                                    {{ formatDate(scope.row[item.key]) }}
                                </div>
                                <div class="text" v-if="item.key == 'pay_time'">
                                    {{ formatDate(scope.row[item.key]) }}
                                </div>
                                <div class="text" v-if="item.key == 'paytype'">
                                    微信支付
                                </div>
                                <div class="text menu" v-if="item.key == 'menu'" @click="applyinvoice(item)">
                                    发票申请
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" :total="total"
                        style="margin-top: 30px; float: right; margin-right: 60px" :current-page="current_page"
                        :page-size="page_size" @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            <paylog :payvisible="payvisible" @payclose="payclose"></paylog>
        </div>
    </div>
</template>

<script>
import free from '@/assets/pay/free-bg.png'
import pay from '@/assets/pay/pay-bg.png'
import { getorderlist, getUserinfo } from '@/api/new'
import paylog from '@/components/paylog.vue'

export default {
    name: 'order',
    components: {
        paylog
    },
    data() {
        return {
            free,
            pay,
            userinfo: {},
            tabelData: [],
            dataSource: [
                { label: '订单编号', key: 'order_sn', width: '180px' },
                { label: '购买内容', key: 'goods_name', width: '160px' },
                { label: '购买时长', key: 'buy_days', width: '' },
                { label: '订单创建时间', key: 'add_time', width: '170px' },
                { label: '订单支付时间', key: 'pay_time', width: '170px' },
                { label: '支付方式', key: 'pay_type', width: '' },
                { label: '实付金额', key: 'amount', width: '' },
                { label: '交易状态', key: 'pay_status', width: '' },
                { label: '申请发票', key: 'menu', width: '' },
            ],
            slotmap: ["add_time", "menu", 'pay_time'],
            total: 0,
            current_page: 1,
            page_size: 8,
            payvisible: false
        }
    },
    methods: {
        getlist() {
            getorderlist().then(res => {
                if (res.status == 200) {
                    this.tabelData = res.data
                    this.total = res.count
                }
            })
        },
        handleSelectionChange() { },
        formatDate(value) {
            if (value == null || value == 0) {
                return '----'
            } else {
                value = value * 1000
                let date = new Date(value);
                let y = date.getFullYear();// 年
                let MM = date.getMonth() + 1;// 月
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();// 日
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();// 时
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();// 分
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();// 秒
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            }
        },
        handleCurrentChange(e) {
            this.current_page = e
        },
        applyinvoice(item) {
            this.$confirm('确认要申请该订单的发票吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
            .then(async () => {

            })
            .catch(() => {
                
            })
        },
        openUp() {
            this.payvisible = true
        },
        payclose() {
            this.payvisible = false
        },
        getUser() {
            getUserinfo().then(res => {
                if (res.status == 200) {
                    this.userinfo = res.data
                }
            })
        },
    },
    mounted() {
        this.getlist()
        this.getUser()
    }
}
</script>

<style scoped lang="scss">
.order {
    height: 100%;
    width: 1380px;

    .order-top {
        width: 100%;
        height: 302px;
        position: relative;
    }

    .order-head {
        width: 100%;
        height: 64px;
        background: linear-gradient(90deg, #EFF2F5, #E1E5EC);
        box-shadow: 0px 1px 0px 0px #E4E4E5;
        display: flex;
        align-items: center;
        padding-left: 24px;
        box-sizing: border-box;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #414B5E;
        line-height: 16px;
    }

    .order-head2 {
        width: 100%;
        height: 64px;
        box-shadow: 0px 1px 0px 0px #E4E4E5;
        display: flex;
        align-items: center;
        padding-left: 24px;
        box-sizing: border-box;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #414B5E;
        line-height: 16px;
    }

    .order-line {
        width: 3px;
        height: 12px;
        background: #414B5E;
        border-radius: 2px;
        margin-right: 8px;
    }

    .order-line1 {
        width: 3px;
        height: 12px;
        background: #0089FF;
        border-radius: 2px;
        margin-right: 8px;
    }

    .top-hover {
        width: 500px;
        height: 240px;
        position: absolute;
        right: 0;
        top: 0;
        &.pay {
            width: 818px;
        }
    }

    .order-content1 {
        background: #fff;
        width: 100%;
        height: 240px;
        padding: 26px 0 0 40px;
        box-sizing: border-box;
        position: relative;
    }

    .content-text {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #626366;
        line-height: 14px;

        em {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #212121;
            line-height: 14px;
        }

        &+.content-text {
            margin-top: 26px;
        }
    }

    .order-content2 {
        margin-top: 18px;
        height: 590px;
        width: 100%;
        background: #fff;
    }

    .up-btn {
        position: absolute;
        bottom: 18px;
        left: 38px;
    }

    .order-list {
        padding: 28px 26px;

        .text {
            &.menu {
                color: #0089FF;
                cursor: pointer;
            }
        }
    }
}
</style>